import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint, QueryKey } from '@/constants';
import { postData } from '@/utils/postData';

export const useAddGiftCard = (onAddSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: postData(Endpoint.AddGiftCard),
    onSuccess: data => {
      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );

      if (data.isSuccess) {
        queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });
        onAddSuccess?.();
      }
    },
  });

  return { addGiftCard: mutate, isPending };
};
